module.exports = __webpack_public_path__ + "static/img/03@2x.b8767595.png";